export default __webpack_public_path__ + "static/media/img-buildbg.360a2e38.svg";